/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as AuthedRouteRouteImport } from './routes/_authed/route';
import { Route as errorsNotFoundRouteImport } from './routes/(errors)/not-found';
import { Route as publicFirstLoginRouteImport } from './routes/(public)/first-login';
import { Route as publicForgotPasswordRouteImport } from './routes/(public)/forgot-password';
import { Route as publicForgotUsernameRouteImport } from './routes/(public)/forgot-username';
import { Route as publicLoginRouteImport } from './routes/(public)/login';
import { Route as publicLogoutRouteImport } from './routes/(public)/logout';
import { Route as publicPrivacyRouteImport } from './routes/(public)/privacy';
import { Route as publicResetPasswordRouteImport } from './routes/(public)/reset-password';
import { Route as publicSessionExpiredRouteImport } from './routes/(public)/session-expired';
import { Route as AuthedIndexRouteImport } from './routes/_authed/index';
import { Route as AuthedAdminRouteRouteImport } from './routes/_authed/_admin/route';
import { Route as AuthedAddressBookRouteImport } from './routes/_authed/address-book';
import { Route as AuthedHelpRouteImport } from './routes/_authed/help';
import { Route as AuthedProfileRouteImport } from './routes/_authed/profile';
import { Route as AuthedReturnsRouteImport } from './routes/_authed/returns';
import { Route as publicFirstLoginFormRouteImport } from './routes/(public)/first-login_.form';
import { Route as publicResetPasswordFormRouteImport } from './routes/(public)/reset-password_.form';
import { Route as AuthedAdminManageRouteImport } from './routes/_authed/_admin/manage';
import { Route as AuthedCartIndexRouteImport } from './routes/_authed/cart.index';
import { Route as AuthedCartStepRouteImport } from './routes/_authed/cart.$step';
import { Route as AuthedOrdersPoNumberRouteImport } from './routes/_authed/orders.$poNumber';
import { Route as AuthedOrdersSearchRouteImport } from './routes/_authed/orders.search';
import { Route as AuthedReturnsOrderNumberRouteImport } from './routes/_authed/returns_.$orderNumber';
import { Route as AuthedAdminApprovalsLocationRouteImport } from './routes/_authed/_admin/approvals.location';
import { Route as AuthedAdminApprovalsOrdersRouteImport } from './routes/_authed/_admin/approvals.orders';
import { Route as AuthedAdminContentAnnouncementsRouteImport } from './routes/_authed/_admin/content.announcements';
import { Route as AuthedAdminContentFaqRouteImport } from './routes/_authed/_admin/content.faq';
import { Route as AuthedAdminContentFileManagerRouteImport } from './routes/_authed/_admin/content.file-manager';
import { Route as AuthedAdminContentProjectsRouteImport } from './routes/_authed/_admin/content.projects';
import { Route as AuthedAdminDistroHistoryRouteImport } from './routes/_authed/_admin/distro.history';
import { Route as AuthedAdminDistroUploadRouteImport } from './routes/_authed/_admin/distro.upload';
import { Route as AuthedAdminManageAddressesRouteImport } from './routes/_authed/_admin/manage.addresses';
import { Route as AuthedAdminManageCountriesRouteImport } from './routes/_authed/_admin/manage.countries';
import { Route as AuthedAdminManageCurrenciesRouteImport } from './routes/_authed/_admin/manage.currencies';
import { Route as AuthedAdminManageCustomersRouteImport } from './routes/_authed/_admin/manage.customers';
import { Route as AuthedAdminManageLineOfBusinessRouteImport } from './routes/_authed/_admin/manage.line-of-business';
import { Route as AuthedAdminManageLocationsRouteImport } from './routes/_authed/_admin/manage.locations';
import { Route as AuthedAdminManageMerchandisersRouteImport } from './routes/_authed/_admin/manage.merchandisers';
import { Route as AuthedAdminManagePlantsRouteImport } from './routes/_authed/_admin/manage.plants';
import { Route as AuthedAdminManageProductsRouteImport } from './routes/_authed/_admin/manage.products';
import { Route as AuthedAdminManageProgramsRouteImport } from './routes/_authed/_admin/manage.programs';
import { Route as AuthedAdminManageSubprogramsRouteImport } from './routes/_authed/_admin/manage.subprograms';
import { Route as AuthedAdminManageUsersRouteImport } from './routes/_authed/_admin/manage.users';
import { Route as AuthedAdminReportsEmailsRouteImport } from './routes/_authed/_admin/reports/emails';
import { Route as AuthedAdminReportsLocationFeedRouteImport } from './routes/_authed/_admin/reports/location-feed';
import { Route as AuthedAdminReportsProductsRouteImport } from './routes/_authed/_admin/reports/products';
import { Route as AuthedAdminReportsSupportRequestsRouteImport } from './routes/_authed/_admin/reports/supportRequests';
import { Route as AuthedAdminReportsUsersRouteImport } from './routes/_authed/_admin/reports/users';
import { Route as AuthedCartCartIdConfirmationRouteImport } from './routes/_authed/cart.$cartId.confirmation';
import { Route as AuthedAdminApprovalsLocationUserIdRouteImport } from './routes/_authed/_admin/approvals.location_.$userId';
import { Route as AuthedAdminApprovalsOrdersPoNumberRouteImport } from './routes/_authed/_admin/approvals.orders_.$poNumber';
import { Route as AuthedAdminContentAnnouncementsAnnouncementIdRouteImport } from './routes/_authed/_admin/content.announcements_.$announcementId';
import { Route as AuthedAdminContentAnnouncementsAddRouteImport } from './routes/_authed/_admin/content.announcements_.add';
import { Route as AuthedAdminContentFaqFaqIdRouteImport } from './routes/_authed/_admin/content.faq_.$faqId';
import { Route as AuthedAdminContentFaqAddRouteImport } from './routes/_authed/_admin/content.faq_.add';
import { Route as AuthedAdminContentFileManagerDetailRouteImport } from './routes/_authed/_admin/content.file-manager_.detail';
import { Route as AuthedAdminContentFileManagerUploadRouteImport } from './routes/_authed/_admin/content.file-manager_.upload';
import { Route as AuthedAdminManageAddressesAddressBookIdRouteImport } from './routes/_authed/_admin/manage.addresses_.$addressBookId';
import { Route as AuthedAdminManageCountriesCountryCodeRouteImport } from './routes/_authed/_admin/manage.countries_.$countryCode';
import { Route as AuthedAdminManageCountriesAddRouteImport } from './routes/_authed/_admin/manage.countries_.add';
import { Route as AuthedAdminManageCurrenciesAddRouteImport } from './routes/_authed/_admin/manage.currencies_.add';
import { Route as AuthedAdminManageCustomersCustomerCodeRouteImport } from './routes/_authed/_admin/manage.customers_.$customerCode';
import { Route as AuthedAdminManageCustomersAddRouteImport } from './routes/_authed/_admin/manage.customers_.add';
import { Route as AuthedAdminManageMerchandisersLocationIdRouteImport } from './routes/_authed/_admin/manage.merchandisers_.$locationId';
import { Route as AuthedAdminManageMerchandisersAddRouteImport } from './routes/_authed/_admin/manage.merchandisers_.add';
import { Route as AuthedAdminManagePlantsWarehouseLocationIdRouteImport } from './routes/_authed/_admin/manage.plants_.$warehouseLocationId';
import { Route as AuthedAdminManageProductsItemIdRouteImport } from './routes/_authed/_admin/manage.products_.$itemId';
import { Route as AuthedAdminManageProductsAddRouteImport } from './routes/_authed/_admin/manage.products_.add';
import { Route as AuthedAdminManageProgramsProgramIdRouteImport } from './routes/_authed/_admin/manage.programs_.$programId';
import { Route as AuthedAdminManageProgramsAddRouteImport } from './routes/_authed/_admin/manage.programs_.add';
import { Route as AuthedAdminManageSubprogramsAddRouteImport } from './routes/_authed/_admin/manage.subprograms_.add';
import { Route as AuthedAdminManageUsersUserNameRouteImport } from './routes/_authed/_admin/manage.users_.$userName';
import { Route as AuthedAdminManageUsersAddRouteImport } from './routes/_authed/_admin/manage.users_.add';
import { Route as AuthedAdminReportsEmailsEmailIdRouteImport } from './routes/_authed/_admin/reports/emails_.$emailId';
import { Route as AuthedAdminReportsLocationFeedLocationIdRouteImport } from './routes/_authed/_admin/reports/location-feed_.$locationId';
import { Route as AuthedAdminReportsSupportRequestsEmailIdRouteImport } from './routes/_authed/_admin/reports/supportRequests_.$emailId';
import { Route as AuthedAdminManageCurrenciesFromCurrencyToCurrencyRouteImport } from './routes/_authed/_admin/manage.currencies_.$fromCurrency_.$toCurrency';
import { Route as AuthedAdminManageSubprogramsCustomerIdCountryCodeRouteImport } from './routes/_authed/_admin/manage.subprograms_.$customerId_.$countryCode';

const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any);
const errorsNotFoundRoute = errorsNotFoundRouteImport.update({
  id: '/(errors)/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any);
const publicFirstLoginRoute = publicFirstLoginRouteImport.update({
  id: '/(public)/first-login',
  path: '/first-login',
  getParentRoute: () => rootRouteImport,
} as any);
const publicForgotPasswordRoute = publicForgotPasswordRouteImport.update({
  id: '/(public)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any);
const publicForgotUsernameRoute = publicForgotUsernameRouteImport.update({
  id: '/(public)/forgot-username',
  path: '/forgot-username',
  getParentRoute: () => rootRouteImport,
} as any);
const publicLoginRoute = publicLoginRouteImport.update({
  id: '/(public)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const publicLogoutRoute = publicLogoutRouteImport.update({
  id: '/(public)/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any);
const publicPrivacyRoute = publicPrivacyRouteImport.update({
  id: '/(public)/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any);
const publicResetPasswordRoute = publicResetPasswordRouteImport.update({
  id: '/(public)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any);
const publicSessionExpiredRoute = publicSessionExpiredRouteImport.update({
  id: '/(public)/session-expired',
  path: '/session-expired',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedAdminRouteRoute = AuthedAdminRouteRouteImport.update({
  id: '/_admin',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedAddressBookRoute = AuthedAddressBookRouteImport.update({
  id: '/address-book',
  path: '/address-book',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedHelpRoute = AuthedHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedReturnsRoute = AuthedReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const publicFirstLoginFormRoute = publicFirstLoginFormRouteImport.update({
  id: '/(public)/first-login_/form',
  path: '/first-login/form',
  getParentRoute: () => rootRouteImport,
} as any);
const publicResetPasswordFormRoute = publicResetPasswordFormRouteImport.update({
  id: '/(public)/reset-password_/form',
  path: '/reset-password/form',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedAdminManageRoute = AuthedAdminManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => AuthedAdminRouteRoute,
} as any);
const AuthedCartIndexRoute = AuthedCartIndexRouteImport.update({
  id: '/cart/',
  path: '/cart/',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedCartStepRoute = AuthedCartStepRouteImport.update({
  id: '/cart/$step',
  path: '/cart/$step',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedOrdersPoNumberRoute = AuthedOrdersPoNumberRouteImport.update({
  id: '/orders/$poNumber',
  path: '/orders/$poNumber',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedOrdersSearchRoute = AuthedOrdersSearchRouteImport.update({
  id: '/orders/search',
  path: '/orders/search',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedReturnsOrderNumberRoute =
  AuthedReturnsOrderNumberRouteImport.update({
    id: '/returns_/$orderNumber',
    path: '/returns/$orderNumber',
    getParentRoute: () => AuthedRouteRoute,
  } as any);
const AuthedAdminApprovalsLocationRoute =
  AuthedAdminApprovalsLocationRouteImport.update({
    id: '/approvals/location',
    path: '/approvals/location',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminApprovalsOrdersRoute =
  AuthedAdminApprovalsOrdersRouteImport.update({
    id: '/approvals/orders',
    path: '/approvals/orders',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentAnnouncementsRoute =
  AuthedAdminContentAnnouncementsRouteImport.update({
    id: '/content/announcements',
    path: '/content/announcements',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentFaqRoute = AuthedAdminContentFaqRouteImport.update({
  id: '/content/faq',
  path: '/content/faq',
  getParentRoute: () => AuthedAdminRouteRoute,
} as any);
const AuthedAdminContentFileManagerRoute =
  AuthedAdminContentFileManagerRouteImport.update({
    id: '/content/file-manager',
    path: '/content/file-manager',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentProjectsRoute =
  AuthedAdminContentProjectsRouteImport.update({
    id: '/content/projects',
    path: '/content/projects',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminDistroHistoryRoute =
  AuthedAdminDistroHistoryRouteImport.update({
    id: '/distro/history',
    path: '/distro/history',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminDistroUploadRoute = AuthedAdminDistroUploadRouteImport.update({
  id: '/distro/upload',
  path: '/distro/upload',
  getParentRoute: () => AuthedAdminRouteRoute,
} as any);
const AuthedAdminManageAddressesRoute =
  AuthedAdminManageAddressesRouteImport.update({
    id: '/addresses',
    path: '/addresses',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageCountriesRoute =
  AuthedAdminManageCountriesRouteImport.update({
    id: '/countries',
    path: '/countries',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageCurrenciesRoute =
  AuthedAdminManageCurrenciesRouteImport.update({
    id: '/currencies',
    path: '/currencies',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageCustomersRoute =
  AuthedAdminManageCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageLineOfBusinessRoute =
  AuthedAdminManageLineOfBusinessRouteImport.update({
    id: '/line-of-business',
    path: '/line-of-business',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageLocationsRoute =
  AuthedAdminManageLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageMerchandisersRoute =
  AuthedAdminManageMerchandisersRouteImport.update({
    id: '/merchandisers',
    path: '/merchandisers',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManagePlantsRoute = AuthedAdminManagePlantsRouteImport.update({
  id: '/plants',
  path: '/plants',
  getParentRoute: () => AuthedAdminManageRoute,
} as any);
const AuthedAdminManageProductsRoute =
  AuthedAdminManageProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageProgramsRoute =
  AuthedAdminManageProgramsRouteImport.update({
    id: '/programs',
    path: '/programs',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageSubprogramsRoute =
  AuthedAdminManageSubprogramsRouteImport.update({
    id: '/subprograms',
    path: '/subprograms',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageUsersRoute = AuthedAdminManageUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedAdminManageRoute,
} as any);
const AuthedAdminReportsEmailsRoute =
  AuthedAdminReportsEmailsRouteImport.update({
    id: '/reports/emails',
    path: '/reports/emails',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminReportsLocationFeedRoute =
  AuthedAdminReportsLocationFeedRouteImport.update({
    id: '/reports/location-feed',
    path: '/reports/location-feed',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminReportsProductsRoute =
  AuthedAdminReportsProductsRouteImport.update({
    id: '/reports/products',
    path: '/reports/products',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminReportsSupportRequestsRoute =
  AuthedAdminReportsSupportRequestsRouteImport.update({
    id: '/reports/supportRequests',
    path: '/reports/supportRequests',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminReportsUsersRoute = AuthedAdminReportsUsersRouteImport.update({
  id: '/reports/users',
  path: '/reports/users',
  getParentRoute: () => AuthedAdminRouteRoute,
} as any);
const AuthedCartCartIdConfirmationRoute =
  AuthedCartCartIdConfirmationRouteImport.update({
    id: '/cart/$cartId/confirmation',
    path: '/cart/$cartId/confirmation',
    getParentRoute: () => AuthedRouteRoute,
  } as any);
const AuthedAdminApprovalsLocationUserIdRoute =
  AuthedAdminApprovalsLocationUserIdRouteImport.update({
    id: '/approvals/location_/$userId',
    path: '/approvals/location/$userId',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminApprovalsOrdersPoNumberRoute =
  AuthedAdminApprovalsOrdersPoNumberRouteImport.update({
    id: '/approvals/orders_/$poNumber',
    path: '/approvals/orders/$poNumber',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentAnnouncementsAnnouncementIdRoute =
  AuthedAdminContentAnnouncementsAnnouncementIdRouteImport.update({
    id: '/content/announcements_/$announcementId',
    path: '/content/announcements/$announcementId',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentAnnouncementsAddRoute =
  AuthedAdminContentAnnouncementsAddRouteImport.update({
    id: '/content/announcements_/add',
    path: '/content/announcements/add',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentFaqFaqIdRoute =
  AuthedAdminContentFaqFaqIdRouteImport.update({
    id: '/content/faq_/$faqId',
    path: '/content/faq/$faqId',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentFaqAddRoute =
  AuthedAdminContentFaqAddRouteImport.update({
    id: '/content/faq_/add',
    path: '/content/faq/add',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentFileManagerDetailRoute =
  AuthedAdminContentFileManagerDetailRouteImport.update({
    id: '/content/file-manager_/detail',
    path: '/content/file-manager/detail',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentFileManagerUploadRoute =
  AuthedAdminContentFileManagerUploadRouteImport.update({
    id: '/content/file-manager_/upload',
    path: '/content/file-manager/upload',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminManageAddressesAddressBookIdRoute =
  AuthedAdminManageAddressesAddressBookIdRouteImport.update({
    id: '/addresses_/$addressBookId',
    path: '/addresses/$addressBookId',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageCountriesCountryCodeRoute =
  AuthedAdminManageCountriesCountryCodeRouteImport.update({
    id: '/countries_/$countryCode',
    path: '/countries/$countryCode',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageCountriesAddRoute =
  AuthedAdminManageCountriesAddRouteImport.update({
    id: '/countries_/add',
    path: '/countries/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageCurrenciesAddRoute =
  AuthedAdminManageCurrenciesAddRouteImport.update({
    id: '/currencies_/add',
    path: '/currencies/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageCustomersCustomerCodeRoute =
  AuthedAdminManageCustomersCustomerCodeRouteImport.update({
    id: '/customers_/$customerCode',
    path: '/customers/$customerCode',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageCustomersAddRoute =
  AuthedAdminManageCustomersAddRouteImport.update({
    id: '/customers_/add',
    path: '/customers/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageMerchandisersLocationIdRoute =
  AuthedAdminManageMerchandisersLocationIdRouteImport.update({
    id: '/merchandisers_/$locationId',
    path: '/merchandisers/$locationId',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageMerchandisersAddRoute =
  AuthedAdminManageMerchandisersAddRouteImport.update({
    id: '/merchandisers_/add',
    path: '/merchandisers/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManagePlantsWarehouseLocationIdRoute =
  AuthedAdminManagePlantsWarehouseLocationIdRouteImport.update({
    id: '/plants_/$warehouseLocationId',
    path: '/plants/$warehouseLocationId',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageProductsItemIdRoute =
  AuthedAdminManageProductsItemIdRouteImport.update({
    id: '/products_/$itemId',
    path: '/products/$itemId',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageProductsAddRoute =
  AuthedAdminManageProductsAddRouteImport.update({
    id: '/products_/add',
    path: '/products/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageProgramsProgramIdRoute =
  AuthedAdminManageProgramsProgramIdRouteImport.update({
    id: '/programs_/$programId',
    path: '/programs/$programId',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageProgramsAddRoute =
  AuthedAdminManageProgramsAddRouteImport.update({
    id: '/programs_/add',
    path: '/programs/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageSubprogramsAddRoute =
  AuthedAdminManageSubprogramsAddRouteImport.update({
    id: '/subprograms_/add',
    path: '/subprograms/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageUsersUserNameRoute =
  AuthedAdminManageUsersUserNameRouteImport.update({
    id: '/users_/$userName',
    path: '/users/$userName',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageUsersAddRoute =
  AuthedAdminManageUsersAddRouteImport.update({
    id: '/users_/add',
    path: '/users/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminReportsEmailsEmailIdRoute =
  AuthedAdminReportsEmailsEmailIdRouteImport.update({
    id: '/reports/emails_/$emailId',
    path: '/reports/emails/$emailId',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminReportsLocationFeedLocationIdRoute =
  AuthedAdminReportsLocationFeedLocationIdRouteImport.update({
    id: '/reports/location-feed_/$locationId',
    path: '/reports/location-feed/$locationId',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminReportsSupportRequestsEmailIdRoute =
  AuthedAdminReportsSupportRequestsEmailIdRouteImport.update({
    id: '/reports/supportRequests_/$emailId',
    path: '/reports/supportRequests/$emailId',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminManageCurrenciesFromCurrencyToCurrencyRoute =
  AuthedAdminManageCurrenciesFromCurrencyToCurrencyRouteImport.update({
    id: '/currencies_/$fromCurrency_/$toCurrency',
    path: '/currencies/$fromCurrency/$toCurrency',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageSubprogramsCustomerIdCountryCodeRoute =
  AuthedAdminManageSubprogramsCustomerIdCountryCodeRouteImport.update({
    id: '/subprograms_/$customerId_/$countryCode',
    path: '/subprograms/$customerId/$countryCode',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute;
  '/not-found': typeof errorsNotFoundRoute;
  '/first-login': typeof publicFirstLoginRoute;
  '/forgot-password': typeof publicForgotPasswordRoute;
  '/forgot-username': typeof publicForgotUsernameRoute;
  '/login': typeof publicLoginRoute;
  '/logout': typeof publicLogoutRoute;
  '/privacy': typeof publicPrivacyRoute;
  '/reset-password': typeof publicResetPasswordRoute;
  '/session-expired': typeof publicSessionExpiredRoute;
  '/address-book': typeof AuthedAddressBookRoute;
  '/help': typeof AuthedHelpRoute;
  '/profile': typeof AuthedProfileRoute;
  '/returns': typeof AuthedReturnsRoute;
  '/first-login/form': typeof publicFirstLoginFormRoute;
  '/reset-password/form': typeof publicResetPasswordFormRoute;
  '/manage': typeof AuthedAdminManageRouteWithChildren;
  '/cart/$step': typeof AuthedCartStepRoute;
  '/orders/$poNumber': typeof AuthedOrdersPoNumberRoute;
  '/orders/search': typeof AuthedOrdersSearchRoute;
  '/returns/$orderNumber': typeof AuthedReturnsOrderNumberRoute;
  '/cart/': typeof AuthedCartIndexRoute;
  '/approvals/location': typeof AuthedAdminApprovalsLocationRoute;
  '/approvals/orders': typeof AuthedAdminApprovalsOrdersRoute;
  '/content/announcements': typeof AuthedAdminContentAnnouncementsRoute;
  '/content/faq': typeof AuthedAdminContentFaqRoute;
  '/content/file-manager': typeof AuthedAdminContentFileManagerRoute;
  '/content/projects': typeof AuthedAdminContentProjectsRoute;
  '/distro/history': typeof AuthedAdminDistroHistoryRoute;
  '/distro/upload': typeof AuthedAdminDistroUploadRoute;
  '/manage/addresses': typeof AuthedAdminManageAddressesRoute;
  '/manage/countries': typeof AuthedAdminManageCountriesRoute;
  '/manage/currencies': typeof AuthedAdminManageCurrenciesRoute;
  '/manage/customers': typeof AuthedAdminManageCustomersRoute;
  '/manage/line-of-business': typeof AuthedAdminManageLineOfBusinessRoute;
  '/manage/locations': typeof AuthedAdminManageLocationsRoute;
  '/manage/merchandisers': typeof AuthedAdminManageMerchandisersRoute;
  '/manage/plants': typeof AuthedAdminManagePlantsRoute;
  '/manage/products': typeof AuthedAdminManageProductsRoute;
  '/manage/programs': typeof AuthedAdminManageProgramsRoute;
  '/manage/subprograms': typeof AuthedAdminManageSubprogramsRoute;
  '/manage/users': typeof AuthedAdminManageUsersRoute;
  '/reports/emails': typeof AuthedAdminReportsEmailsRoute;
  '/reports/location-feed': typeof AuthedAdminReportsLocationFeedRoute;
  '/reports/products': typeof AuthedAdminReportsProductsRoute;
  '/reports/supportRequests': typeof AuthedAdminReportsSupportRequestsRoute;
  '/reports/users': typeof AuthedAdminReportsUsersRoute;
  '/cart/$cartId/confirmation': typeof AuthedCartCartIdConfirmationRoute;
  '/approvals/location/$userId': typeof AuthedAdminApprovalsLocationUserIdRoute;
  '/approvals/orders/$poNumber': typeof AuthedAdminApprovalsOrdersPoNumberRoute;
  '/content/announcements/$announcementId': typeof AuthedAdminContentAnnouncementsAnnouncementIdRoute;
  '/content/announcements/add': typeof AuthedAdminContentAnnouncementsAddRoute;
  '/content/faq/$faqId': typeof AuthedAdminContentFaqFaqIdRoute;
  '/content/faq/add': typeof AuthedAdminContentFaqAddRoute;
  '/content/file-manager/detail': typeof AuthedAdminContentFileManagerDetailRoute;
  '/content/file-manager/upload': typeof AuthedAdminContentFileManagerUploadRoute;
  '/manage/addresses/$addressBookId': typeof AuthedAdminManageAddressesAddressBookIdRoute;
  '/manage/countries/$countryCode': typeof AuthedAdminManageCountriesCountryCodeRoute;
  '/manage/countries/add': typeof AuthedAdminManageCountriesAddRoute;
  '/manage/currencies/add': typeof AuthedAdminManageCurrenciesAddRoute;
  '/manage/customers/$customerCode': typeof AuthedAdminManageCustomersCustomerCodeRoute;
  '/manage/customers/add': typeof AuthedAdminManageCustomersAddRoute;
  '/manage/merchandisers/$locationId': typeof AuthedAdminManageMerchandisersLocationIdRoute;
  '/manage/merchandisers/add': typeof AuthedAdminManageMerchandisersAddRoute;
  '/manage/plants/$warehouseLocationId': typeof AuthedAdminManagePlantsWarehouseLocationIdRoute;
  '/manage/products/$itemId': typeof AuthedAdminManageProductsItemIdRoute;
  '/manage/products/add': typeof AuthedAdminManageProductsAddRoute;
  '/manage/programs/$programId': typeof AuthedAdminManageProgramsProgramIdRoute;
  '/manage/programs/add': typeof AuthedAdminManageProgramsAddRoute;
  '/manage/subprograms/add': typeof AuthedAdminManageSubprogramsAddRoute;
  '/manage/users/$userName': typeof AuthedAdminManageUsersUserNameRoute;
  '/manage/users/add': typeof AuthedAdminManageUsersAddRoute;
  '/reports/emails/$emailId': typeof AuthedAdminReportsEmailsEmailIdRoute;
  '/reports/location-feed/$locationId': typeof AuthedAdminReportsLocationFeedLocationIdRoute;
  '/reports/supportRequests/$emailId': typeof AuthedAdminReportsSupportRequestsEmailIdRoute;
  '/manage/currencies/$fromCurrency/$toCurrency': typeof AuthedAdminManageCurrenciesFromCurrencyToCurrencyRoute;
  '/manage/subprograms/$customerId/$countryCode': typeof AuthedAdminManageSubprogramsCustomerIdCountryCodeRoute;
}
export interface FileRoutesByTo {
  '/': typeof AuthedIndexRoute;
  '/not-found': typeof errorsNotFoundRoute;
  '/first-login': typeof publicFirstLoginRoute;
  '/forgot-password': typeof publicForgotPasswordRoute;
  '/forgot-username': typeof publicForgotUsernameRoute;
  '/login': typeof publicLoginRoute;
  '/logout': typeof publicLogoutRoute;
  '/privacy': typeof publicPrivacyRoute;
  '/reset-password': typeof publicResetPasswordRoute;
  '/session-expired': typeof publicSessionExpiredRoute;
  '/address-book': typeof AuthedAddressBookRoute;
  '/help': typeof AuthedHelpRoute;
  '/profile': typeof AuthedProfileRoute;
  '/returns': typeof AuthedReturnsRoute;
  '/first-login/form': typeof publicFirstLoginFormRoute;
  '/reset-password/form': typeof publicResetPasswordFormRoute;
  '/manage': typeof AuthedAdminManageRouteWithChildren;
  '/cart/$step': typeof AuthedCartStepRoute;
  '/orders/$poNumber': typeof AuthedOrdersPoNumberRoute;
  '/orders/search': typeof AuthedOrdersSearchRoute;
  '/returns/$orderNumber': typeof AuthedReturnsOrderNumberRoute;
  '/cart': typeof AuthedCartIndexRoute;
  '/approvals/location': typeof AuthedAdminApprovalsLocationRoute;
  '/approvals/orders': typeof AuthedAdminApprovalsOrdersRoute;
  '/content/announcements': typeof AuthedAdminContentAnnouncementsRoute;
  '/content/faq': typeof AuthedAdminContentFaqRoute;
  '/content/file-manager': typeof AuthedAdminContentFileManagerRoute;
  '/content/projects': typeof AuthedAdminContentProjectsRoute;
  '/distro/history': typeof AuthedAdminDistroHistoryRoute;
  '/distro/upload': typeof AuthedAdminDistroUploadRoute;
  '/manage/addresses': typeof AuthedAdminManageAddressesRoute;
  '/manage/countries': typeof AuthedAdminManageCountriesRoute;
  '/manage/currencies': typeof AuthedAdminManageCurrenciesRoute;
  '/manage/customers': typeof AuthedAdminManageCustomersRoute;
  '/manage/line-of-business': typeof AuthedAdminManageLineOfBusinessRoute;
  '/manage/locations': typeof AuthedAdminManageLocationsRoute;
  '/manage/merchandisers': typeof AuthedAdminManageMerchandisersRoute;
  '/manage/plants': typeof AuthedAdminManagePlantsRoute;
  '/manage/products': typeof AuthedAdminManageProductsRoute;
  '/manage/programs': typeof AuthedAdminManageProgramsRoute;
  '/manage/subprograms': typeof AuthedAdminManageSubprogramsRoute;
  '/manage/users': typeof AuthedAdminManageUsersRoute;
  '/reports/emails': typeof AuthedAdminReportsEmailsRoute;
  '/reports/location-feed': typeof AuthedAdminReportsLocationFeedRoute;
  '/reports/products': typeof AuthedAdminReportsProductsRoute;
  '/reports/supportRequests': typeof AuthedAdminReportsSupportRequestsRoute;
  '/reports/users': typeof AuthedAdminReportsUsersRoute;
  '/cart/$cartId/confirmation': typeof AuthedCartCartIdConfirmationRoute;
  '/approvals/location/$userId': typeof AuthedAdminApprovalsLocationUserIdRoute;
  '/approvals/orders/$poNumber': typeof AuthedAdminApprovalsOrdersPoNumberRoute;
  '/content/announcements/$announcementId': typeof AuthedAdminContentAnnouncementsAnnouncementIdRoute;
  '/content/announcements/add': typeof AuthedAdminContentAnnouncementsAddRoute;
  '/content/faq/$faqId': typeof AuthedAdminContentFaqFaqIdRoute;
  '/content/faq/add': typeof AuthedAdminContentFaqAddRoute;
  '/content/file-manager/detail': typeof AuthedAdminContentFileManagerDetailRoute;
  '/content/file-manager/upload': typeof AuthedAdminContentFileManagerUploadRoute;
  '/manage/addresses/$addressBookId': typeof AuthedAdminManageAddressesAddressBookIdRoute;
  '/manage/countries/$countryCode': typeof AuthedAdminManageCountriesCountryCodeRoute;
  '/manage/countries/add': typeof AuthedAdminManageCountriesAddRoute;
  '/manage/currencies/add': typeof AuthedAdminManageCurrenciesAddRoute;
  '/manage/customers/$customerCode': typeof AuthedAdminManageCustomersCustomerCodeRoute;
  '/manage/customers/add': typeof AuthedAdminManageCustomersAddRoute;
  '/manage/merchandisers/$locationId': typeof AuthedAdminManageMerchandisersLocationIdRoute;
  '/manage/merchandisers/add': typeof AuthedAdminManageMerchandisersAddRoute;
  '/manage/plants/$warehouseLocationId': typeof AuthedAdminManagePlantsWarehouseLocationIdRoute;
  '/manage/products/$itemId': typeof AuthedAdminManageProductsItemIdRoute;
  '/manage/products/add': typeof AuthedAdminManageProductsAddRoute;
  '/manage/programs/$programId': typeof AuthedAdminManageProgramsProgramIdRoute;
  '/manage/programs/add': typeof AuthedAdminManageProgramsAddRoute;
  '/manage/subprograms/add': typeof AuthedAdminManageSubprogramsAddRoute;
  '/manage/users/$userName': typeof AuthedAdminManageUsersUserNameRoute;
  '/manage/users/add': typeof AuthedAdminManageUsersAddRoute;
  '/reports/emails/$emailId': typeof AuthedAdminReportsEmailsEmailIdRoute;
  '/reports/location-feed/$locationId': typeof AuthedAdminReportsLocationFeedLocationIdRoute;
  '/reports/supportRequests/$emailId': typeof AuthedAdminReportsSupportRequestsEmailIdRoute;
  '/manage/currencies/$fromCurrency/$toCurrency': typeof AuthedAdminManageCurrenciesFromCurrencyToCurrencyRoute;
  '/manage/subprograms/$customerId/$countryCode': typeof AuthedAdminManageSubprogramsCustomerIdCountryCodeRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_authed': typeof AuthedRouteRouteWithChildren;
  '/_authed/_admin': typeof AuthedAdminRouteRouteWithChildren;
  '/(errors)/not-found': typeof errorsNotFoundRoute;
  '/(public)/first-login': typeof publicFirstLoginRoute;
  '/(public)/forgot-password': typeof publicForgotPasswordRoute;
  '/(public)/forgot-username': typeof publicForgotUsernameRoute;
  '/(public)/login': typeof publicLoginRoute;
  '/(public)/logout': typeof publicLogoutRoute;
  '/(public)/privacy': typeof publicPrivacyRoute;
  '/(public)/reset-password': typeof publicResetPasswordRoute;
  '/(public)/session-expired': typeof publicSessionExpiredRoute;
  '/_authed/address-book': typeof AuthedAddressBookRoute;
  '/_authed/help': typeof AuthedHelpRoute;
  '/_authed/profile': typeof AuthedProfileRoute;
  '/_authed/returns': typeof AuthedReturnsRoute;
  '/_authed/': typeof AuthedIndexRoute;
  '/(public)/first-login_/form': typeof publicFirstLoginFormRoute;
  '/(public)/reset-password_/form': typeof publicResetPasswordFormRoute;
  '/_authed/_admin/manage': typeof AuthedAdminManageRouteWithChildren;
  '/_authed/cart/$step': typeof AuthedCartStepRoute;
  '/_authed/orders/$poNumber': typeof AuthedOrdersPoNumberRoute;
  '/_authed/orders/search': typeof AuthedOrdersSearchRoute;
  '/_authed/returns_/$orderNumber': typeof AuthedReturnsOrderNumberRoute;
  '/_authed/cart/': typeof AuthedCartIndexRoute;
  '/_authed/_admin/approvals/location': typeof AuthedAdminApprovalsLocationRoute;
  '/_authed/_admin/approvals/orders': typeof AuthedAdminApprovalsOrdersRoute;
  '/_authed/_admin/content/announcements': typeof AuthedAdminContentAnnouncementsRoute;
  '/_authed/_admin/content/faq': typeof AuthedAdminContentFaqRoute;
  '/_authed/_admin/content/file-manager': typeof AuthedAdminContentFileManagerRoute;
  '/_authed/_admin/content/projects': typeof AuthedAdminContentProjectsRoute;
  '/_authed/_admin/distro/history': typeof AuthedAdminDistroHistoryRoute;
  '/_authed/_admin/distro/upload': typeof AuthedAdminDistroUploadRoute;
  '/_authed/_admin/manage/addresses': typeof AuthedAdminManageAddressesRoute;
  '/_authed/_admin/manage/countries': typeof AuthedAdminManageCountriesRoute;
  '/_authed/_admin/manage/currencies': typeof AuthedAdminManageCurrenciesRoute;
  '/_authed/_admin/manage/customers': typeof AuthedAdminManageCustomersRoute;
  '/_authed/_admin/manage/line-of-business': typeof AuthedAdminManageLineOfBusinessRoute;
  '/_authed/_admin/manage/locations': typeof AuthedAdminManageLocationsRoute;
  '/_authed/_admin/manage/merchandisers': typeof AuthedAdminManageMerchandisersRoute;
  '/_authed/_admin/manage/plants': typeof AuthedAdminManagePlantsRoute;
  '/_authed/_admin/manage/products': typeof AuthedAdminManageProductsRoute;
  '/_authed/_admin/manage/programs': typeof AuthedAdminManageProgramsRoute;
  '/_authed/_admin/manage/subprograms': typeof AuthedAdminManageSubprogramsRoute;
  '/_authed/_admin/manage/users': typeof AuthedAdminManageUsersRoute;
  '/_authed/_admin/reports/emails': typeof AuthedAdminReportsEmailsRoute;
  '/_authed/_admin/reports/location-feed': typeof AuthedAdminReportsLocationFeedRoute;
  '/_authed/_admin/reports/products': typeof AuthedAdminReportsProductsRoute;
  '/_authed/_admin/reports/supportRequests': typeof AuthedAdminReportsSupportRequestsRoute;
  '/_authed/_admin/reports/users': typeof AuthedAdminReportsUsersRoute;
  '/_authed/cart/$cartId/confirmation': typeof AuthedCartCartIdConfirmationRoute;
  '/_authed/_admin/approvals/location_/$userId': typeof AuthedAdminApprovalsLocationUserIdRoute;
  '/_authed/_admin/approvals/orders_/$poNumber': typeof AuthedAdminApprovalsOrdersPoNumberRoute;
  '/_authed/_admin/content/announcements_/$announcementId': typeof AuthedAdminContentAnnouncementsAnnouncementIdRoute;
  '/_authed/_admin/content/announcements_/add': typeof AuthedAdminContentAnnouncementsAddRoute;
  '/_authed/_admin/content/faq_/$faqId': typeof AuthedAdminContentFaqFaqIdRoute;
  '/_authed/_admin/content/faq_/add': typeof AuthedAdminContentFaqAddRoute;
  '/_authed/_admin/content/file-manager_/detail': typeof AuthedAdminContentFileManagerDetailRoute;
  '/_authed/_admin/content/file-manager_/upload': typeof AuthedAdminContentFileManagerUploadRoute;
  '/_authed/_admin/manage/addresses_/$addressBookId': typeof AuthedAdminManageAddressesAddressBookIdRoute;
  '/_authed/_admin/manage/countries_/$countryCode': typeof AuthedAdminManageCountriesCountryCodeRoute;
  '/_authed/_admin/manage/countries_/add': typeof AuthedAdminManageCountriesAddRoute;
  '/_authed/_admin/manage/currencies_/add': typeof AuthedAdminManageCurrenciesAddRoute;
  '/_authed/_admin/manage/customers_/$customerCode': typeof AuthedAdminManageCustomersCustomerCodeRoute;
  '/_authed/_admin/manage/customers_/add': typeof AuthedAdminManageCustomersAddRoute;
  '/_authed/_admin/manage/merchandisers_/$locationId': typeof AuthedAdminManageMerchandisersLocationIdRoute;
  '/_authed/_admin/manage/merchandisers_/add': typeof AuthedAdminManageMerchandisersAddRoute;
  '/_authed/_admin/manage/plants_/$warehouseLocationId': typeof AuthedAdminManagePlantsWarehouseLocationIdRoute;
  '/_authed/_admin/manage/products_/$itemId': typeof AuthedAdminManageProductsItemIdRoute;
  '/_authed/_admin/manage/products_/add': typeof AuthedAdminManageProductsAddRoute;
  '/_authed/_admin/manage/programs_/$programId': typeof AuthedAdminManageProgramsProgramIdRoute;
  '/_authed/_admin/manage/programs_/add': typeof AuthedAdminManageProgramsAddRoute;
  '/_authed/_admin/manage/subprograms_/add': typeof AuthedAdminManageSubprogramsAddRoute;
  '/_authed/_admin/manage/users_/$userName': typeof AuthedAdminManageUsersUserNameRoute;
  '/_authed/_admin/manage/users_/add': typeof AuthedAdminManageUsersAddRoute;
  '/_authed/_admin/reports/emails_/$emailId': typeof AuthedAdminReportsEmailsEmailIdRoute;
  '/_authed/_admin/reports/location-feed_/$locationId': typeof AuthedAdminReportsLocationFeedLocationIdRoute;
  '/_authed/_admin/reports/supportRequests_/$emailId': typeof AuthedAdminReportsSupportRequestsEmailIdRoute;
  '/_authed/_admin/manage/currencies_/$fromCurrency_/$toCurrency': typeof AuthedAdminManageCurrenciesFromCurrencyToCurrencyRoute;
  '/_authed/_admin/manage/subprograms_/$customerId_/$countryCode': typeof AuthedAdminManageSubprogramsCustomerIdCountryCodeRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/not-found'
    | '/first-login'
    | '/forgot-password'
    | '/forgot-username'
    | '/login'
    | '/logout'
    | '/privacy'
    | '/reset-password'
    | '/session-expired'
    | '/address-book'
    | '/help'
    | '/profile'
    | '/returns'
    | '/first-login/form'
    | '/reset-password/form'
    | '/manage'
    | '/cart/$step'
    | '/orders/$poNumber'
    | '/orders/search'
    | '/returns/$orderNumber'
    | '/cart/'
    | '/approvals/location'
    | '/approvals/orders'
    | '/content/announcements'
    | '/content/faq'
    | '/content/file-manager'
    | '/content/projects'
    | '/distro/history'
    | '/distro/upload'
    | '/manage/addresses'
    | '/manage/countries'
    | '/manage/currencies'
    | '/manage/customers'
    | '/manage/line-of-business'
    | '/manage/locations'
    | '/manage/merchandisers'
    | '/manage/plants'
    | '/manage/products'
    | '/manage/programs'
    | '/manage/subprograms'
    | '/manage/users'
    | '/reports/emails'
    | '/reports/location-feed'
    | '/reports/products'
    | '/reports/supportRequests'
    | '/reports/users'
    | '/cart/$cartId/confirmation'
    | '/approvals/location/$userId'
    | '/approvals/orders/$poNumber'
    | '/content/announcements/$announcementId'
    | '/content/announcements/add'
    | '/content/faq/$faqId'
    | '/content/faq/add'
    | '/content/file-manager/detail'
    | '/content/file-manager/upload'
    | '/manage/addresses/$addressBookId'
    | '/manage/countries/$countryCode'
    | '/manage/countries/add'
    | '/manage/currencies/add'
    | '/manage/customers/$customerCode'
    | '/manage/customers/add'
    | '/manage/merchandisers/$locationId'
    | '/manage/merchandisers/add'
    | '/manage/plants/$warehouseLocationId'
    | '/manage/products/$itemId'
    | '/manage/products/add'
    | '/manage/programs/$programId'
    | '/manage/programs/add'
    | '/manage/subprograms/add'
    | '/manage/users/$userName'
    | '/manage/users/add'
    | '/reports/emails/$emailId'
    | '/reports/location-feed/$locationId'
    | '/reports/supportRequests/$emailId'
    | '/manage/currencies/$fromCurrency/$toCurrency'
    | '/manage/subprograms/$customerId/$countryCode';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/not-found'
    | '/first-login'
    | '/forgot-password'
    | '/forgot-username'
    | '/login'
    | '/logout'
    | '/privacy'
    | '/reset-password'
    | '/session-expired'
    | '/address-book'
    | '/help'
    | '/profile'
    | '/returns'
    | '/first-login/form'
    | '/reset-password/form'
    | '/manage'
    | '/cart/$step'
    | '/orders/$poNumber'
    | '/orders/search'
    | '/returns/$orderNumber'
    | '/cart'
    | '/approvals/location'
    | '/approvals/orders'
    | '/content/announcements'
    | '/content/faq'
    | '/content/file-manager'
    | '/content/projects'
    | '/distro/history'
    | '/distro/upload'
    | '/manage/addresses'
    | '/manage/countries'
    | '/manage/currencies'
    | '/manage/customers'
    | '/manage/line-of-business'
    | '/manage/locations'
    | '/manage/merchandisers'
    | '/manage/plants'
    | '/manage/products'
    | '/manage/programs'
    | '/manage/subprograms'
    | '/manage/users'
    | '/reports/emails'
    | '/reports/location-feed'
    | '/reports/products'
    | '/reports/supportRequests'
    | '/reports/users'
    | '/cart/$cartId/confirmation'
    | '/approvals/location/$userId'
    | '/approvals/orders/$poNumber'
    | '/content/announcements/$announcementId'
    | '/content/announcements/add'
    | '/content/faq/$faqId'
    | '/content/faq/add'
    | '/content/file-manager/detail'
    | '/content/file-manager/upload'
    | '/manage/addresses/$addressBookId'
    | '/manage/countries/$countryCode'
    | '/manage/countries/add'
    | '/manage/currencies/add'
    | '/manage/customers/$customerCode'
    | '/manage/customers/add'
    | '/manage/merchandisers/$locationId'
    | '/manage/merchandisers/add'
    | '/manage/plants/$warehouseLocationId'
    | '/manage/products/$itemId'
    | '/manage/products/add'
    | '/manage/programs/$programId'
    | '/manage/programs/add'
    | '/manage/subprograms/add'
    | '/manage/users/$userName'
    | '/manage/users/add'
    | '/reports/emails/$emailId'
    | '/reports/location-feed/$locationId'
    | '/reports/supportRequests/$emailId'
    | '/manage/currencies/$fromCurrency/$toCurrency'
    | '/manage/subprograms/$customerId/$countryCode';
  id:
    | '__root__'
    | '/_authed'
    | '/_authed/_admin'
    | '/(errors)/not-found'
    | '/(public)/first-login'
    | '/(public)/forgot-password'
    | '/(public)/forgot-username'
    | '/(public)/login'
    | '/(public)/logout'
    | '/(public)/privacy'
    | '/(public)/reset-password'
    | '/(public)/session-expired'
    | '/_authed/address-book'
    | '/_authed/help'
    | '/_authed/profile'
    | '/_authed/returns'
    | '/_authed/'
    | '/(public)/first-login_/form'
    | '/(public)/reset-password_/form'
    | '/_authed/_admin/manage'
    | '/_authed/cart/$step'
    | '/_authed/orders/$poNumber'
    | '/_authed/orders/search'
    | '/_authed/returns_/$orderNumber'
    | '/_authed/cart/'
    | '/_authed/_admin/approvals/location'
    | '/_authed/_admin/approvals/orders'
    | '/_authed/_admin/content/announcements'
    | '/_authed/_admin/content/faq'
    | '/_authed/_admin/content/file-manager'
    | '/_authed/_admin/content/projects'
    | '/_authed/_admin/distro/history'
    | '/_authed/_admin/distro/upload'
    | '/_authed/_admin/manage/addresses'
    | '/_authed/_admin/manage/countries'
    | '/_authed/_admin/manage/currencies'
    | '/_authed/_admin/manage/customers'
    | '/_authed/_admin/manage/line-of-business'
    | '/_authed/_admin/manage/locations'
    | '/_authed/_admin/manage/merchandisers'
    | '/_authed/_admin/manage/plants'
    | '/_authed/_admin/manage/products'
    | '/_authed/_admin/manage/programs'
    | '/_authed/_admin/manage/subprograms'
    | '/_authed/_admin/manage/users'
    | '/_authed/_admin/reports/emails'
    | '/_authed/_admin/reports/location-feed'
    | '/_authed/_admin/reports/products'
    | '/_authed/_admin/reports/supportRequests'
    | '/_authed/_admin/reports/users'
    | '/_authed/cart/$cartId/confirmation'
    | '/_authed/_admin/approvals/location_/$userId'
    | '/_authed/_admin/approvals/orders_/$poNumber'
    | '/_authed/_admin/content/announcements_/$announcementId'
    | '/_authed/_admin/content/announcements_/add'
    | '/_authed/_admin/content/faq_/$faqId'
    | '/_authed/_admin/content/faq_/add'
    | '/_authed/_admin/content/file-manager_/detail'
    | '/_authed/_admin/content/file-manager_/upload'
    | '/_authed/_admin/manage/addresses_/$addressBookId'
    | '/_authed/_admin/manage/countries_/$countryCode'
    | '/_authed/_admin/manage/countries_/add'
    | '/_authed/_admin/manage/currencies_/add'
    | '/_authed/_admin/manage/customers_/$customerCode'
    | '/_authed/_admin/manage/customers_/add'
    | '/_authed/_admin/manage/merchandisers_/$locationId'
    | '/_authed/_admin/manage/merchandisers_/add'
    | '/_authed/_admin/manage/plants_/$warehouseLocationId'
    | '/_authed/_admin/manage/products_/$itemId'
    | '/_authed/_admin/manage/products_/add'
    | '/_authed/_admin/manage/programs_/$programId'
    | '/_authed/_admin/manage/programs_/add'
    | '/_authed/_admin/manage/subprograms_/add'
    | '/_authed/_admin/manage/users_/$userName'
    | '/_authed/_admin/manage/users_/add'
    | '/_authed/_admin/reports/emails_/$emailId'
    | '/_authed/_admin/reports/location-feed_/$locationId'
    | '/_authed/_admin/reports/supportRequests_/$emailId'
    | '/_authed/_admin/manage/currencies_/$fromCurrency_/$toCurrency'
    | '/_authed/_admin/manage/subprograms_/$customerId_/$countryCode';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren;
  errorsNotFoundRoute: typeof errorsNotFoundRoute;
  publicFirstLoginRoute: typeof publicFirstLoginRoute;
  publicForgotPasswordRoute: typeof publicForgotPasswordRoute;
  publicForgotUsernameRoute: typeof publicForgotUsernameRoute;
  publicLoginRoute: typeof publicLoginRoute;
  publicLogoutRoute: typeof publicLogoutRoute;
  publicPrivacyRoute: typeof publicPrivacyRoute;
  publicResetPasswordRoute: typeof publicResetPasswordRoute;
  publicSessionExpiredRoute: typeof publicSessionExpiredRoute;
  publicFirstLoginFormRoute: typeof publicFirstLoginFormRoute;
  publicResetPasswordFormRoute: typeof publicResetPasswordFormRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthedRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(errors)/not-found': {
      id: '/(errors)/not-found';
      path: '/not-found';
      fullPath: '/not-found';
      preLoaderRoute: typeof errorsNotFoundRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/first-login': {
      id: '/(public)/first-login';
      path: '/first-login';
      fullPath: '/first-login';
      preLoaderRoute: typeof publicFirstLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/forgot-password': {
      id: '/(public)/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof publicForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/forgot-username': {
      id: '/(public)/forgot-username';
      path: '/forgot-username';
      fullPath: '/forgot-username';
      preLoaderRoute: typeof publicForgotUsernameRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/login': {
      id: '/(public)/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof publicLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/logout': {
      id: '/(public)/logout';
      path: '/logout';
      fullPath: '/logout';
      preLoaderRoute: typeof publicLogoutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/privacy': {
      id: '/(public)/privacy';
      path: '/privacy';
      fullPath: '/privacy';
      preLoaderRoute: typeof publicPrivacyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/reset-password': {
      id: '/(public)/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof publicResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/session-expired': {
      id: '/(public)/session-expired';
      path: '/session-expired';
      fullPath: '/session-expired';
      preLoaderRoute: typeof publicSessionExpiredRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authed/': {
      id: '/_authed/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthedIndexRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/_admin': {
      id: '/_authed/_admin';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthedAdminRouteRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/address-book': {
      id: '/_authed/address-book';
      path: '/address-book';
      fullPath: '/address-book';
      preLoaderRoute: typeof AuthedAddressBookRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/help': {
      id: '/_authed/help';
      path: '/help';
      fullPath: '/help';
      preLoaderRoute: typeof AuthedHelpRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/profile': {
      id: '/_authed/profile';
      path: '/profile';
      fullPath: '/profile';
      preLoaderRoute: typeof AuthedProfileRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/returns': {
      id: '/_authed/returns';
      path: '/returns';
      fullPath: '/returns';
      preLoaderRoute: typeof AuthedReturnsRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/(public)/first-login_/form': {
      id: '/(public)/first-login_/form';
      path: '/first-login/form';
      fullPath: '/first-login/form';
      preLoaderRoute: typeof publicFirstLoginFormRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/reset-password_/form': {
      id: '/(public)/reset-password_/form';
      path: '/reset-password/form';
      fullPath: '/reset-password/form';
      preLoaderRoute: typeof publicResetPasswordFormRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authed/_admin/manage': {
      id: '/_authed/_admin/manage';
      path: '/manage';
      fullPath: '/manage';
      preLoaderRoute: typeof AuthedAdminManageRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/cart/': {
      id: '/_authed/cart/';
      path: '/cart';
      fullPath: '/cart/';
      preLoaderRoute: typeof AuthedCartIndexRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/cart/$step': {
      id: '/_authed/cart/$step';
      path: '/cart/$step';
      fullPath: '/cart/$step';
      preLoaderRoute: typeof AuthedCartStepRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/orders/$poNumber': {
      id: '/_authed/orders/$poNumber';
      path: '/orders/$poNumber';
      fullPath: '/orders/$poNumber';
      preLoaderRoute: typeof AuthedOrdersPoNumberRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/orders/search': {
      id: '/_authed/orders/search';
      path: '/orders/search';
      fullPath: '/orders/search';
      preLoaderRoute: typeof AuthedOrdersSearchRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/returns_/$orderNumber': {
      id: '/_authed/returns_/$orderNumber';
      path: '/returns/$orderNumber';
      fullPath: '/returns/$orderNumber';
      preLoaderRoute: typeof AuthedReturnsOrderNumberRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/_admin/approvals/location': {
      id: '/_authed/_admin/approvals/location';
      path: '/approvals/location';
      fullPath: '/approvals/location';
      preLoaderRoute: typeof AuthedAdminApprovalsLocationRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/approvals/orders': {
      id: '/_authed/_admin/approvals/orders';
      path: '/approvals/orders';
      fullPath: '/approvals/orders';
      preLoaderRoute: typeof AuthedAdminApprovalsOrdersRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/announcements': {
      id: '/_authed/_admin/content/announcements';
      path: '/content/announcements';
      fullPath: '/content/announcements';
      preLoaderRoute: typeof AuthedAdminContentAnnouncementsRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/faq': {
      id: '/_authed/_admin/content/faq';
      path: '/content/faq';
      fullPath: '/content/faq';
      preLoaderRoute: typeof AuthedAdminContentFaqRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/file-manager': {
      id: '/_authed/_admin/content/file-manager';
      path: '/content/file-manager';
      fullPath: '/content/file-manager';
      preLoaderRoute: typeof AuthedAdminContentFileManagerRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/projects': {
      id: '/_authed/_admin/content/projects';
      path: '/content/projects';
      fullPath: '/content/projects';
      preLoaderRoute: typeof AuthedAdminContentProjectsRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/distro/history': {
      id: '/_authed/_admin/distro/history';
      path: '/distro/history';
      fullPath: '/distro/history';
      preLoaderRoute: typeof AuthedAdminDistroHistoryRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/distro/upload': {
      id: '/_authed/_admin/distro/upload';
      path: '/distro/upload';
      fullPath: '/distro/upload';
      preLoaderRoute: typeof AuthedAdminDistroUploadRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/manage/addresses': {
      id: '/_authed/_admin/manage/addresses';
      path: '/addresses';
      fullPath: '/manage/addresses';
      preLoaderRoute: typeof AuthedAdminManageAddressesRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/countries': {
      id: '/_authed/_admin/manage/countries';
      path: '/countries';
      fullPath: '/manage/countries';
      preLoaderRoute: typeof AuthedAdminManageCountriesRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/currencies': {
      id: '/_authed/_admin/manage/currencies';
      path: '/currencies';
      fullPath: '/manage/currencies';
      preLoaderRoute: typeof AuthedAdminManageCurrenciesRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/customers': {
      id: '/_authed/_admin/manage/customers';
      path: '/customers';
      fullPath: '/manage/customers';
      preLoaderRoute: typeof AuthedAdminManageCustomersRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/line-of-business': {
      id: '/_authed/_admin/manage/line-of-business';
      path: '/line-of-business';
      fullPath: '/manage/line-of-business';
      preLoaderRoute: typeof AuthedAdminManageLineOfBusinessRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/locations': {
      id: '/_authed/_admin/manage/locations';
      path: '/locations';
      fullPath: '/manage/locations';
      preLoaderRoute: typeof AuthedAdminManageLocationsRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/merchandisers': {
      id: '/_authed/_admin/manage/merchandisers';
      path: '/merchandisers';
      fullPath: '/manage/merchandisers';
      preLoaderRoute: typeof AuthedAdminManageMerchandisersRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/plants': {
      id: '/_authed/_admin/manage/plants';
      path: '/plants';
      fullPath: '/manage/plants';
      preLoaderRoute: typeof AuthedAdminManagePlantsRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/products': {
      id: '/_authed/_admin/manage/products';
      path: '/products';
      fullPath: '/manage/products';
      preLoaderRoute: typeof AuthedAdminManageProductsRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/programs': {
      id: '/_authed/_admin/manage/programs';
      path: '/programs';
      fullPath: '/manage/programs';
      preLoaderRoute: typeof AuthedAdminManageProgramsRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/subprograms': {
      id: '/_authed/_admin/manage/subprograms';
      path: '/subprograms';
      fullPath: '/manage/subprograms';
      preLoaderRoute: typeof AuthedAdminManageSubprogramsRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/users': {
      id: '/_authed/_admin/manage/users';
      path: '/users';
      fullPath: '/manage/users';
      preLoaderRoute: typeof AuthedAdminManageUsersRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/reports/emails': {
      id: '/_authed/_admin/reports/emails';
      path: '/reports/emails';
      fullPath: '/reports/emails';
      preLoaderRoute: typeof AuthedAdminReportsEmailsRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/reports/location-feed': {
      id: '/_authed/_admin/reports/location-feed';
      path: '/reports/location-feed';
      fullPath: '/reports/location-feed';
      preLoaderRoute: typeof AuthedAdminReportsLocationFeedRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/reports/products': {
      id: '/_authed/_admin/reports/products';
      path: '/reports/products';
      fullPath: '/reports/products';
      preLoaderRoute: typeof AuthedAdminReportsProductsRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/reports/supportRequests': {
      id: '/_authed/_admin/reports/supportRequests';
      path: '/reports/supportRequests';
      fullPath: '/reports/supportRequests';
      preLoaderRoute: typeof AuthedAdminReportsSupportRequestsRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/reports/users': {
      id: '/_authed/_admin/reports/users';
      path: '/reports/users';
      fullPath: '/reports/users';
      preLoaderRoute: typeof AuthedAdminReportsUsersRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/cart/$cartId/confirmation': {
      id: '/_authed/cart/$cartId/confirmation';
      path: '/cart/$cartId/confirmation';
      fullPath: '/cart/$cartId/confirmation';
      preLoaderRoute: typeof AuthedCartCartIdConfirmationRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/_admin/approvals/location_/$userId': {
      id: '/_authed/_admin/approvals/location_/$userId';
      path: '/approvals/location/$userId';
      fullPath: '/approvals/location/$userId';
      preLoaderRoute: typeof AuthedAdminApprovalsLocationUserIdRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/approvals/orders_/$poNumber': {
      id: '/_authed/_admin/approvals/orders_/$poNumber';
      path: '/approvals/orders/$poNumber';
      fullPath: '/approvals/orders/$poNumber';
      preLoaderRoute: typeof AuthedAdminApprovalsOrdersPoNumberRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/announcements_/$announcementId': {
      id: '/_authed/_admin/content/announcements_/$announcementId';
      path: '/content/announcements/$announcementId';
      fullPath: '/content/announcements/$announcementId';
      preLoaderRoute: typeof AuthedAdminContentAnnouncementsAnnouncementIdRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/announcements_/add': {
      id: '/_authed/_admin/content/announcements_/add';
      path: '/content/announcements/add';
      fullPath: '/content/announcements/add';
      preLoaderRoute: typeof AuthedAdminContentAnnouncementsAddRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/faq_/$faqId': {
      id: '/_authed/_admin/content/faq_/$faqId';
      path: '/content/faq/$faqId';
      fullPath: '/content/faq/$faqId';
      preLoaderRoute: typeof AuthedAdminContentFaqFaqIdRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/faq_/add': {
      id: '/_authed/_admin/content/faq_/add';
      path: '/content/faq/add';
      fullPath: '/content/faq/add';
      preLoaderRoute: typeof AuthedAdminContentFaqAddRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/file-manager_/detail': {
      id: '/_authed/_admin/content/file-manager_/detail';
      path: '/content/file-manager/detail';
      fullPath: '/content/file-manager/detail';
      preLoaderRoute: typeof AuthedAdminContentFileManagerDetailRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/file-manager_/upload': {
      id: '/_authed/_admin/content/file-manager_/upload';
      path: '/content/file-manager/upload';
      fullPath: '/content/file-manager/upload';
      preLoaderRoute: typeof AuthedAdminContentFileManagerUploadRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/manage/addresses_/$addressBookId': {
      id: '/_authed/_admin/manage/addresses_/$addressBookId';
      path: '/addresses/$addressBookId';
      fullPath: '/manage/addresses/$addressBookId';
      preLoaderRoute: typeof AuthedAdminManageAddressesAddressBookIdRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/countries_/$countryCode': {
      id: '/_authed/_admin/manage/countries_/$countryCode';
      path: '/countries/$countryCode';
      fullPath: '/manage/countries/$countryCode';
      preLoaderRoute: typeof AuthedAdminManageCountriesCountryCodeRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/countries_/add': {
      id: '/_authed/_admin/manage/countries_/add';
      path: '/countries/add';
      fullPath: '/manage/countries/add';
      preLoaderRoute: typeof AuthedAdminManageCountriesAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/currencies_/add': {
      id: '/_authed/_admin/manage/currencies_/add';
      path: '/currencies/add';
      fullPath: '/manage/currencies/add';
      preLoaderRoute: typeof AuthedAdminManageCurrenciesAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/customers_/$customerCode': {
      id: '/_authed/_admin/manage/customers_/$customerCode';
      path: '/customers/$customerCode';
      fullPath: '/manage/customers/$customerCode';
      preLoaderRoute: typeof AuthedAdminManageCustomersCustomerCodeRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/customers_/add': {
      id: '/_authed/_admin/manage/customers_/add';
      path: '/customers/add';
      fullPath: '/manage/customers/add';
      preLoaderRoute: typeof AuthedAdminManageCustomersAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/merchandisers_/$locationId': {
      id: '/_authed/_admin/manage/merchandisers_/$locationId';
      path: '/merchandisers/$locationId';
      fullPath: '/manage/merchandisers/$locationId';
      preLoaderRoute: typeof AuthedAdminManageMerchandisersLocationIdRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/merchandisers_/add': {
      id: '/_authed/_admin/manage/merchandisers_/add';
      path: '/merchandisers/add';
      fullPath: '/manage/merchandisers/add';
      preLoaderRoute: typeof AuthedAdminManageMerchandisersAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/plants_/$warehouseLocationId': {
      id: '/_authed/_admin/manage/plants_/$warehouseLocationId';
      path: '/plants/$warehouseLocationId';
      fullPath: '/manage/plants/$warehouseLocationId';
      preLoaderRoute: typeof AuthedAdminManagePlantsWarehouseLocationIdRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/products_/$itemId': {
      id: '/_authed/_admin/manage/products_/$itemId';
      path: '/products/$itemId';
      fullPath: '/manage/products/$itemId';
      preLoaderRoute: typeof AuthedAdminManageProductsItemIdRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/products_/add': {
      id: '/_authed/_admin/manage/products_/add';
      path: '/products/add';
      fullPath: '/manage/products/add';
      preLoaderRoute: typeof AuthedAdminManageProductsAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/programs_/$programId': {
      id: '/_authed/_admin/manage/programs_/$programId';
      path: '/programs/$programId';
      fullPath: '/manage/programs/$programId';
      preLoaderRoute: typeof AuthedAdminManageProgramsProgramIdRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/programs_/add': {
      id: '/_authed/_admin/manage/programs_/add';
      path: '/programs/add';
      fullPath: '/manage/programs/add';
      preLoaderRoute: typeof AuthedAdminManageProgramsAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/subprograms_/add': {
      id: '/_authed/_admin/manage/subprograms_/add';
      path: '/subprograms/add';
      fullPath: '/manage/subprograms/add';
      preLoaderRoute: typeof AuthedAdminManageSubprogramsAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/users_/$userName': {
      id: '/_authed/_admin/manage/users_/$userName';
      path: '/users/$userName';
      fullPath: '/manage/users/$userName';
      preLoaderRoute: typeof AuthedAdminManageUsersUserNameRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/users_/add': {
      id: '/_authed/_admin/manage/users_/add';
      path: '/users/add';
      fullPath: '/manage/users/add';
      preLoaderRoute: typeof AuthedAdminManageUsersAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/reports/emails_/$emailId': {
      id: '/_authed/_admin/reports/emails_/$emailId';
      path: '/reports/emails/$emailId';
      fullPath: '/reports/emails/$emailId';
      preLoaderRoute: typeof AuthedAdminReportsEmailsEmailIdRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/reports/location-feed_/$locationId': {
      id: '/_authed/_admin/reports/location-feed_/$locationId';
      path: '/reports/location-feed/$locationId';
      fullPath: '/reports/location-feed/$locationId';
      preLoaderRoute: typeof AuthedAdminReportsLocationFeedLocationIdRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/reports/supportRequests_/$emailId': {
      id: '/_authed/_admin/reports/supportRequests_/$emailId';
      path: '/reports/supportRequests/$emailId';
      fullPath: '/reports/supportRequests/$emailId';
      preLoaderRoute: typeof AuthedAdminReportsSupportRequestsEmailIdRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/manage/currencies_/$fromCurrency_/$toCurrency': {
      id: '/_authed/_admin/manage/currencies_/$fromCurrency_/$toCurrency';
      path: '/currencies/$fromCurrency/$toCurrency';
      fullPath: '/manage/currencies/$fromCurrency/$toCurrency';
      preLoaderRoute: typeof AuthedAdminManageCurrenciesFromCurrencyToCurrencyRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/subprograms_/$customerId_/$countryCode': {
      id: '/_authed/_admin/manage/subprograms_/$customerId_/$countryCode';
      path: '/subprograms/$customerId/$countryCode';
      fullPath: '/manage/subprograms/$customerId/$countryCode';
      preLoaderRoute: typeof AuthedAdminManageSubprogramsCustomerIdCountryCodeRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
  }
}

interface AuthedAdminManageRouteChildren {
  AuthedAdminManageAddressesRoute: typeof AuthedAdminManageAddressesRoute;
  AuthedAdminManageCountriesRoute: typeof AuthedAdminManageCountriesRoute;
  AuthedAdminManageCurrenciesRoute: typeof AuthedAdminManageCurrenciesRoute;
  AuthedAdminManageCustomersRoute: typeof AuthedAdminManageCustomersRoute;
  AuthedAdminManageLineOfBusinessRoute: typeof AuthedAdminManageLineOfBusinessRoute;
  AuthedAdminManageLocationsRoute: typeof AuthedAdminManageLocationsRoute;
  AuthedAdminManageMerchandisersRoute: typeof AuthedAdminManageMerchandisersRoute;
  AuthedAdminManagePlantsRoute: typeof AuthedAdminManagePlantsRoute;
  AuthedAdminManageProductsRoute: typeof AuthedAdminManageProductsRoute;
  AuthedAdminManageProgramsRoute: typeof AuthedAdminManageProgramsRoute;
  AuthedAdminManageSubprogramsRoute: typeof AuthedAdminManageSubprogramsRoute;
  AuthedAdminManageUsersRoute: typeof AuthedAdminManageUsersRoute;
  AuthedAdminManageAddressesAddressBookIdRoute: typeof AuthedAdminManageAddressesAddressBookIdRoute;
  AuthedAdminManageCountriesCountryCodeRoute: typeof AuthedAdminManageCountriesCountryCodeRoute;
  AuthedAdminManageCountriesAddRoute: typeof AuthedAdminManageCountriesAddRoute;
  AuthedAdminManageCurrenciesAddRoute: typeof AuthedAdminManageCurrenciesAddRoute;
  AuthedAdminManageCustomersCustomerCodeRoute: typeof AuthedAdminManageCustomersCustomerCodeRoute;
  AuthedAdminManageCustomersAddRoute: typeof AuthedAdminManageCustomersAddRoute;
  AuthedAdminManageMerchandisersLocationIdRoute: typeof AuthedAdminManageMerchandisersLocationIdRoute;
  AuthedAdminManageMerchandisersAddRoute: typeof AuthedAdminManageMerchandisersAddRoute;
  AuthedAdminManagePlantsWarehouseLocationIdRoute: typeof AuthedAdminManagePlantsWarehouseLocationIdRoute;
  AuthedAdminManageProductsItemIdRoute: typeof AuthedAdminManageProductsItemIdRoute;
  AuthedAdminManageProductsAddRoute: typeof AuthedAdminManageProductsAddRoute;
  AuthedAdminManageProgramsProgramIdRoute: typeof AuthedAdminManageProgramsProgramIdRoute;
  AuthedAdminManageProgramsAddRoute: typeof AuthedAdminManageProgramsAddRoute;
  AuthedAdminManageSubprogramsAddRoute: typeof AuthedAdminManageSubprogramsAddRoute;
  AuthedAdminManageUsersUserNameRoute: typeof AuthedAdminManageUsersUserNameRoute;
  AuthedAdminManageUsersAddRoute: typeof AuthedAdminManageUsersAddRoute;
  AuthedAdminManageCurrenciesFromCurrencyToCurrencyRoute: typeof AuthedAdminManageCurrenciesFromCurrencyToCurrencyRoute;
  AuthedAdminManageSubprogramsCustomerIdCountryCodeRoute: typeof AuthedAdminManageSubprogramsCustomerIdCountryCodeRoute;
}

const AuthedAdminManageRouteChildren: AuthedAdminManageRouteChildren = {
  AuthedAdminManageAddressesRoute: AuthedAdminManageAddressesRoute,
  AuthedAdminManageCountriesRoute: AuthedAdminManageCountriesRoute,
  AuthedAdminManageCurrenciesRoute: AuthedAdminManageCurrenciesRoute,
  AuthedAdminManageCustomersRoute: AuthedAdminManageCustomersRoute,
  AuthedAdminManageLineOfBusinessRoute: AuthedAdminManageLineOfBusinessRoute,
  AuthedAdminManageLocationsRoute: AuthedAdminManageLocationsRoute,
  AuthedAdminManageMerchandisersRoute: AuthedAdminManageMerchandisersRoute,
  AuthedAdminManagePlantsRoute: AuthedAdminManagePlantsRoute,
  AuthedAdminManageProductsRoute: AuthedAdminManageProductsRoute,
  AuthedAdminManageProgramsRoute: AuthedAdminManageProgramsRoute,
  AuthedAdminManageSubprogramsRoute: AuthedAdminManageSubprogramsRoute,
  AuthedAdminManageUsersRoute: AuthedAdminManageUsersRoute,
  AuthedAdminManageAddressesAddressBookIdRoute:
    AuthedAdminManageAddressesAddressBookIdRoute,
  AuthedAdminManageCountriesCountryCodeRoute:
    AuthedAdminManageCountriesCountryCodeRoute,
  AuthedAdminManageCountriesAddRoute: AuthedAdminManageCountriesAddRoute,
  AuthedAdminManageCurrenciesAddRoute: AuthedAdminManageCurrenciesAddRoute,
  AuthedAdminManageCustomersCustomerCodeRoute:
    AuthedAdminManageCustomersCustomerCodeRoute,
  AuthedAdminManageCustomersAddRoute: AuthedAdminManageCustomersAddRoute,
  AuthedAdminManageMerchandisersLocationIdRoute:
    AuthedAdminManageMerchandisersLocationIdRoute,
  AuthedAdminManageMerchandisersAddRoute:
    AuthedAdminManageMerchandisersAddRoute,
  AuthedAdminManagePlantsWarehouseLocationIdRoute:
    AuthedAdminManagePlantsWarehouseLocationIdRoute,
  AuthedAdminManageProductsItemIdRoute: AuthedAdminManageProductsItemIdRoute,
  AuthedAdminManageProductsAddRoute: AuthedAdminManageProductsAddRoute,
  AuthedAdminManageProgramsProgramIdRoute:
    AuthedAdminManageProgramsProgramIdRoute,
  AuthedAdminManageProgramsAddRoute: AuthedAdminManageProgramsAddRoute,
  AuthedAdminManageSubprogramsAddRoute: AuthedAdminManageSubprogramsAddRoute,
  AuthedAdminManageUsersUserNameRoute: AuthedAdminManageUsersUserNameRoute,
  AuthedAdminManageUsersAddRoute: AuthedAdminManageUsersAddRoute,
  AuthedAdminManageCurrenciesFromCurrencyToCurrencyRoute:
    AuthedAdminManageCurrenciesFromCurrencyToCurrencyRoute,
  AuthedAdminManageSubprogramsCustomerIdCountryCodeRoute:
    AuthedAdminManageSubprogramsCustomerIdCountryCodeRoute,
};

const AuthedAdminManageRouteWithChildren =
  AuthedAdminManageRoute._addFileChildren(AuthedAdminManageRouteChildren);

interface AuthedAdminRouteRouteChildren {
  AuthedAdminManageRoute: typeof AuthedAdminManageRouteWithChildren;
  AuthedAdminApprovalsLocationRoute: typeof AuthedAdminApprovalsLocationRoute;
  AuthedAdminApprovalsOrdersRoute: typeof AuthedAdminApprovalsOrdersRoute;
  AuthedAdminContentAnnouncementsRoute: typeof AuthedAdminContentAnnouncementsRoute;
  AuthedAdminContentFaqRoute: typeof AuthedAdminContentFaqRoute;
  AuthedAdminContentFileManagerRoute: typeof AuthedAdminContentFileManagerRoute;
  AuthedAdminContentProjectsRoute: typeof AuthedAdminContentProjectsRoute;
  AuthedAdminDistroHistoryRoute: typeof AuthedAdminDistroHistoryRoute;
  AuthedAdminDistroUploadRoute: typeof AuthedAdminDistroUploadRoute;
  AuthedAdminReportsEmailsRoute: typeof AuthedAdminReportsEmailsRoute;
  AuthedAdminReportsLocationFeedRoute: typeof AuthedAdminReportsLocationFeedRoute;
  AuthedAdminReportsProductsRoute: typeof AuthedAdminReportsProductsRoute;
  AuthedAdminReportsSupportRequestsRoute: typeof AuthedAdminReportsSupportRequestsRoute;
  AuthedAdminReportsUsersRoute: typeof AuthedAdminReportsUsersRoute;
  AuthedAdminApprovalsLocationUserIdRoute: typeof AuthedAdminApprovalsLocationUserIdRoute;
  AuthedAdminApprovalsOrdersPoNumberRoute: typeof AuthedAdminApprovalsOrdersPoNumberRoute;
  AuthedAdminContentAnnouncementsAnnouncementIdRoute: typeof AuthedAdminContentAnnouncementsAnnouncementIdRoute;
  AuthedAdminContentAnnouncementsAddRoute: typeof AuthedAdminContentAnnouncementsAddRoute;
  AuthedAdminContentFaqFaqIdRoute: typeof AuthedAdminContentFaqFaqIdRoute;
  AuthedAdminContentFaqAddRoute: typeof AuthedAdminContentFaqAddRoute;
  AuthedAdminContentFileManagerDetailRoute: typeof AuthedAdminContentFileManagerDetailRoute;
  AuthedAdminContentFileManagerUploadRoute: typeof AuthedAdminContentFileManagerUploadRoute;
  AuthedAdminReportsEmailsEmailIdRoute: typeof AuthedAdminReportsEmailsEmailIdRoute;
  AuthedAdminReportsLocationFeedLocationIdRoute: typeof AuthedAdminReportsLocationFeedLocationIdRoute;
  AuthedAdminReportsSupportRequestsEmailIdRoute: typeof AuthedAdminReportsSupportRequestsEmailIdRoute;
}

const AuthedAdminRouteRouteChildren: AuthedAdminRouteRouteChildren = {
  AuthedAdminManageRoute: AuthedAdminManageRouteWithChildren,
  AuthedAdminApprovalsLocationRoute: AuthedAdminApprovalsLocationRoute,
  AuthedAdminApprovalsOrdersRoute: AuthedAdminApprovalsOrdersRoute,
  AuthedAdminContentAnnouncementsRoute: AuthedAdminContentAnnouncementsRoute,
  AuthedAdminContentFaqRoute: AuthedAdminContentFaqRoute,
  AuthedAdminContentFileManagerRoute: AuthedAdminContentFileManagerRoute,
  AuthedAdminContentProjectsRoute: AuthedAdminContentProjectsRoute,
  AuthedAdminDistroHistoryRoute: AuthedAdminDistroHistoryRoute,
  AuthedAdminDistroUploadRoute: AuthedAdminDistroUploadRoute,
  AuthedAdminReportsEmailsRoute: AuthedAdminReportsEmailsRoute,
  AuthedAdminReportsLocationFeedRoute: AuthedAdminReportsLocationFeedRoute,
  AuthedAdminReportsProductsRoute: AuthedAdminReportsProductsRoute,
  AuthedAdminReportsSupportRequestsRoute:
    AuthedAdminReportsSupportRequestsRoute,
  AuthedAdminReportsUsersRoute: AuthedAdminReportsUsersRoute,
  AuthedAdminApprovalsLocationUserIdRoute:
    AuthedAdminApprovalsLocationUserIdRoute,
  AuthedAdminApprovalsOrdersPoNumberRoute:
    AuthedAdminApprovalsOrdersPoNumberRoute,
  AuthedAdminContentAnnouncementsAnnouncementIdRoute:
    AuthedAdminContentAnnouncementsAnnouncementIdRoute,
  AuthedAdminContentAnnouncementsAddRoute:
    AuthedAdminContentAnnouncementsAddRoute,
  AuthedAdminContentFaqFaqIdRoute: AuthedAdminContentFaqFaqIdRoute,
  AuthedAdminContentFaqAddRoute: AuthedAdminContentFaqAddRoute,
  AuthedAdminContentFileManagerDetailRoute:
    AuthedAdminContentFileManagerDetailRoute,
  AuthedAdminContentFileManagerUploadRoute:
    AuthedAdminContentFileManagerUploadRoute,
  AuthedAdminReportsEmailsEmailIdRoute: AuthedAdminReportsEmailsEmailIdRoute,
  AuthedAdminReportsLocationFeedLocationIdRoute:
    AuthedAdminReportsLocationFeedLocationIdRoute,
  AuthedAdminReportsSupportRequestsEmailIdRoute:
    AuthedAdminReportsSupportRequestsEmailIdRoute,
};

const AuthedAdminRouteRouteWithChildren =
  AuthedAdminRouteRoute._addFileChildren(AuthedAdminRouteRouteChildren);

interface AuthedRouteRouteChildren {
  AuthedAdminRouteRoute: typeof AuthedAdminRouteRouteWithChildren;
  AuthedAddressBookRoute: typeof AuthedAddressBookRoute;
  AuthedHelpRoute: typeof AuthedHelpRoute;
  AuthedProfileRoute: typeof AuthedProfileRoute;
  AuthedReturnsRoute: typeof AuthedReturnsRoute;
  AuthedIndexRoute: typeof AuthedIndexRoute;
  AuthedCartStepRoute: typeof AuthedCartStepRoute;
  AuthedOrdersPoNumberRoute: typeof AuthedOrdersPoNumberRoute;
  AuthedOrdersSearchRoute: typeof AuthedOrdersSearchRoute;
  AuthedReturnsOrderNumberRoute: typeof AuthedReturnsOrderNumberRoute;
  AuthedCartIndexRoute: typeof AuthedCartIndexRoute;
  AuthedCartCartIdConfirmationRoute: typeof AuthedCartCartIdConfirmationRoute;
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedAdminRouteRoute: AuthedAdminRouteRouteWithChildren,
  AuthedAddressBookRoute: AuthedAddressBookRoute,
  AuthedHelpRoute: AuthedHelpRoute,
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedReturnsRoute: AuthedReturnsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedCartStepRoute: AuthedCartStepRoute,
  AuthedOrdersPoNumberRoute: AuthedOrdersPoNumberRoute,
  AuthedOrdersSearchRoute: AuthedOrdersSearchRoute,
  AuthedReturnsOrderNumberRoute: AuthedReturnsOrderNumberRoute,
  AuthedCartIndexRoute: AuthedCartIndexRoute,
  AuthedCartCartIdConfirmationRoute: AuthedCartCartIdConfirmationRoute,
};

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  errorsNotFoundRoute: errorsNotFoundRoute,
  publicFirstLoginRoute: publicFirstLoginRoute,
  publicForgotPasswordRoute: publicForgotPasswordRoute,
  publicForgotUsernameRoute: publicForgotUsernameRoute,
  publicLoginRoute: publicLoginRoute,
  publicLogoutRoute: publicLogoutRoute,
  publicPrivacyRoute: publicPrivacyRoute,
  publicResetPasswordRoute: publicResetPasswordRoute,
  publicSessionExpiredRoute: publicSessionExpiredRoute,
  publicFirstLoginFormRoute: publicFirstLoginFormRoute,
  publicResetPasswordFormRoute: publicResetPasswordFormRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
